import { Button, DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiReplyCodePartners extends Layout {
    buttonDisableAll: Button;
    buttonEnableAll: Button;
    labelHeader: Label;
    sourceEdiReplyCodeQualifiers: DataSource;
    tablePartnerQualifiers: Table;
}
